import { CONFIG } from 'app/config/config';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { ActiveUser } from 'app/shared/services/user/active-user.model';

@Injectable()
export class LoginService {
  email: string;
  constructor(private _http: Http) { }

  login(data: any): Promise<ActiveUser> {
    return this._http.post(CONFIG.ENDPOINT_URL + '/auth/login', data)
      .toPromise()
      .then((u) => {
        return new ActiveUser(u.json());
      })
      .catch(error => {
        if (error && error._body) {
          error = JSON.parse(error._body);
          if (error.message && error.message === 'User is not confirmed') {
            // User is not confirmed
            return Promise.reject(new Error('User is not confirmed'));
          }
        }
        // Otherwise
        return this.handleError();
      });
  }

  resetPassword(resetEmail: string): Promise<any> {
    let body = {
      email: resetEmail
    };
    return this._http.post(CONFIG.ENDPOINT_URL + 'passwords', body)
      .toPromise().catch((error) => {
        return Promise.reject(error.error || error.message || 'Error.');
      });
  }

  setPassword(data: any): Promise<any> {
    let body;
    if (data.app_name) {
      body = {
        password: data.password,
        app_name: data.app_name
      };
    } else {
      body = {
        password: data.password
      };
    }
    return this._http.put(CONFIG.ENDPOINT_URL + '/passwords/' + data.token, body)
      .toPromise()
      .catch((error) => {
        if (error && error._body) {
          error = JSON.parse(error._body);
          return Promise.reject(error.error || error.message || 'Error.');
        } else {
          return Promise.reject('Error');
        }
      });
  }

  confirmEmail(token: string): Promise<any> {
    return this._http.post(CONFIG.ENDPOINT_URL + '/confirm_email/' + token, {})
      .toPromise()
      .catch((error) => {
        if (error && error._body) {
          error = JSON.parse(error._body);
          return Promise.reject(error.error || error.message || 'Error.');
        } else {
          return Promise.reject('Error');
        }
      });
    }

  resendConfirmationEmail(token: string, isCMSUser: boolean): Promise<any> {
    let body = {
      token: token,
      email_action: isCMSUser ? 'create_account' : 'create_mobile_account'
    };
    return this._http.post(CONFIG.ENDPOINT_URL + '/emails/resend', body)
      .toPromise()
      .catch((e) => {
        console.log(e);
      });
  }

  resendPasswordResetEmail(token: string): Promise<any> {
    let body = {
      token: token,
      email_action: 'set_password'
    };
    return this._http.post(CONFIG.ENDPOINT_URL + '/emails/resend', body)
      .toPromise()
      .catch((e) => {
        console.log(e);
    });
  }

  private handleError(error?:any) {
    return Promise.reject(new Error('Invalid login credentials.'));
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/login/login.service.ts